import type { LaunchSummary } from "@bubblefun/shared";
import { marketCap, relativeTime, volumeUsd } from "../lib/format";
import { Link } from "../lib/router";
import { TokenBadge } from "./TokenBadge";

export function MarketTable({ launches, compactMode = false }: { launches: LaunchSummary[]; compactMode?: boolean }) {
  return (
    <div className={`market-table${compactMode ? " market-table--compact" : ""}`}>
      <div className="market-row market-row--head" aria-hidden="true">
        <span>Market</span><span>Market cap</span><span>24h volume</span><span>24h</span><span>Milestone</span><span>Age</span>
      </div>
      {launches.map((launch) => (
        <Link href={`/token/${launch.address}`} className="market-row" key={launch.address}>
          <span className="market-name">
            <TokenBadge symbol={launch.symbol} size="sm" />
            <span><b>{launch.name}</b><small>${launch.symbol}</small></span>
          </span>
          <span data-label="Market cap">{marketCap(launch.marketCapUsd)}</span>
          <span data-label="24h volume">{volumeUsd(launch.volume24hUsd, launch.volume24hEth, launch.marketCapUsd, launch.fdvEth)}</span>
          <span data-label="24h" className={launch.change24h >= 0 ? "is-positive" : "is-negative"}>
            {launch.change24h >= 0 ? "+" : ""}{launch.change24h.toFixed(1)}%
          </span>
          <span data-label="Milestone" className="progress-cell">
            <i><b style={{ width: `${Math.min(100, launch.marketProgress)}%` }} /></i>
            <small>{launch.marketProgress}%</small>
          </span>
          <span data-label="Age">{relativeTime(launch.createdAt)} <small>↗</small></span>
        </Link>
      ))}
      {launches.length === 0 && <div className="empty-row">No markets match this view.</div>}
    </div>
  );
}
